import SkeletonLoader from "components/Skeletons/SkeletonLoader";
import React, { ReactNode } from "react";

interface Props {
    label: ReactNode | string;
    loading?: boolean;
    children: React.ReactNode;
    className?: string;
}

function ProfileDataNode({ label, loading, children, className = '' }: Props) {
    return (
        <div className={`info-field ${className}`}>
            <div className="dataNode-label">{label}</div>
            {loading ? (
                <SkeletonLoader className="m-2" />
            ) : (
                <div className="dataNode-text">{children}</div>
            )}
        </div>
    );
}
export default ProfileDataNode;
